import { useSettings } from './useSetting';

export function useHighContrast(): [
	boolean,
	(value: boolean | undefined) => void,
] {
	const { settings, setValue } = useSettings();
	const highContrast = settings.highContrast ?? false;
	const setHighContrast = (value: boolean | undefined) =>
		setValue('highContrast', value);
	return [highContrast, setHighContrast];
}
